/* 削除確認モーダル */
import CloseIcon from '@assets/images/common/icon/close.svg';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';

const ConfirmMessageDeleteModal: React.FC<{
  onConfirm: () => void;
  onClose: () => void;
  isDeleting?: boolean;
}> = ({ onConfirm, onClose, isDeleting }) => {
  return (
    <Modal width='440px'>
      <div className='relative flex grow flex-col gap-8 p-10 py-9 md:px-6 md:py-8'>
        <div className='border-b border-b-gray-350 pb-[10px] md:pb-5'>
          <h2 className='text-lg font-semibold md:text-xl'>完全に削除しますか？</h2>
        </div>
        <p className='text-sm leading-[1.6]'>メッセージが完全に削除されますがよろしいですか？</p>
        <div className='mt-auto flex w-full justify-between md:flex-col md:gap-4'>
          <div className='w-[172px] md:w-full'>
            <Button
              className='font-medium'
              size='m'
              fullRounded
              fullWidth
              variant='secondary'
              onClick={onConfirm}
              disabled={isDeleting}
            >
              完全に削除
            </Button>
          </div>
          <div className='w-[172px] md:w-full'>
            <Button
              className='font-medium'
              size='m'
              outline
              fullRounded
              fullWidth
              onClick={onClose}
              disabled={isDeleting}
            >
              キャンセル
            </Button>
          </div>
        </div>
        <div className='absolute right-2 top-2 md:right-[10px] md:top-3'>
          <button
            className='grid size-5 place-items-center rounded-full bg-[#F7F7F7]'
            onClick={onClose}
            disabled={isDeleting}
          >
            <img
              src={CloseIcon}
              alt=''
            />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { ConfirmMessageDeleteModal };
